export default __webpack_public_path__ + "static/media/plus.9a20c4c1.svg";